import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-diagnostic-center-address',
  templateUrl: './diagnostic-center-address.component.html',
  styleUrls: ['./diagnostic-center-address.component.scss']
})
export class DiagnosticCenterAddressComponent implements OnInit {

  constructor() { }

  @Input() providerInfoObj;
  diagnosticCenterList = [];
  diagnosticCenterAddress: string='';
  ngOnInit(): void {
   
    this.diagnosticCenterList = this.providerInfoObj.provider_info;
    for (var i = 0; i < this.diagnosticCenterList.length; i++) {

      if (this.diagnosticCenterList[i].component_no == 7 || this.diagnosticCenterList[i].component_no == 5 || this.diagnosticCenterList[i].component_no == 9) {

        // if(this.diagnosticCenterList[i].associate_name !=null)
        // {
        //   this.diagnosticCenterAddress = this.diagnosticCenterList[i].associate_name + "&";
        // }
        // if(this.diagnosticCenterList[i].associate_address !=null)
        // {
        //   this.diagnosticCenterAddress = this.diagnosticCenterAddress +this.diagnosticCenterList[i].associate_address;
        // } opd_c
        if(this.diagnosticCenterList[i].associate_name !=null)
        {
          this.diagnosticCenterAddress = this.diagnosticCenterList[i].associate_name;

        }
        //this.diagnosticCenterAddress = this.diagnosticCenterList[i].associate_name + "&" + this.diagnosticCenterList[i].associate_address;
      }
      
    }

  }
}